export const getDownloadActionLabel = ({
  hasSelection,
  isRootFolder,
  selectedFileCount,
  totalFileCount,
}: {
  hasSelection: boolean;
  isRootFolder: boolean;
  selectedFileCount: number;
  totalFileCount: number;
}) => {
  if (!hasSelection) {
    return isRootFolder ? 'pm:downloadAll' : 'pm:downloadFolder';
  }

  return selectedFileCount >= totalFileCount ? 'pm:downloadAll' : 'pm:downloadSelected';
};

export const shouldShowDownloadAction = ({ hasFiles, totalFileCount }: { hasFiles: boolean; totalFileCount: number }) =>
  hasFiles || totalFileCount > 0;

export const imageMimeType: string[] = ['image/jpeg', 'image/png'];
export const videoMimeType: string[] = ['video/mp4'];

export const docMimeType: string[] = [
  'application/pdf',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  'application/vnd.ms-powerpoint',
];

export const mimeTypeMapper: Record<string, string> = {
  'image/jpeg': 'jpg',
  'image/png': 'png',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'docx',
  'application/pdf': 'pdf',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx',
  'video/mp4': 'mp4',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation': 'pptx',
  'application/vnd.ms-powerpoint': 'ppt',
};
